import { html } from 'lit';
const GeminiDuotone =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill="url(#a)" d="M23 12.022A11.72 11.72 0 0 0 12.022 23h-.044A11.717 11.717 0 0 0 1 12.022v-.044A11.716 11.716 0 0 0 11.978 1h.044A11.72 11.72 0 0 0 23 11.978z"/><defs><radialGradient id="a" cx="0" cy="0" r="1" gradientTransform="rotate(18.683 -28.626 14.647)scale(23.4163 187.579)" gradientUnits="userSpaceOnUse"><stop offset=".067" stop-color="#9168C0"/><stop offset=".343" stop-color="#5684D1"/><stop offset=".672" stop-color="#1BA1E3"/></radialGradient></defs>
  </svg>
`;
export default GeminiDuotone;
